import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_form_title = _resolveComponent("app-form-title")!
  const _component_AppVerifyEmailSucc = _resolveComponent("AppVerifyEmailSucc")!
  const _component_AppVerifyEmailLinkWrong = _resolveComponent("AppVerifyEmailLinkWrong")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_app_form_holder = _resolveComponent("app-form-holder")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_form_holder, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_app_form_title, { title: "Email Verification" })
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          (_ctx.verifiedEmail === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_AppVerifyEmailSucc)
              ]))
            : _createCommentVNode("", true),
          (_ctx.verifiedEmail === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_AppVerifyEmailLinkWrong)
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_space, {
            "w-100": "",
            fill: true,
            alignment: "center",
            direction: "vertical",
            size: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, { type: "primary" }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("Sign In", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}